/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".legendWideControlGroup{margin:0 0 5px}.legendWideControlGroup label{margin-top:4px;font-weight:700}.symbol-editor label{margin-bottom:8px}.color-swatch{display:inline-block;width:50px;height:30px}.color-swatch:hover{cursor:pointer}.cancel-button{margin:7px 7px 0 0}.cancel-button:hover{cursor:pointer}.color-picker .sketch-picker{width:200px}.rangeslider{width:99%}.myCanvas{display:inline-block;width:77.9%;height:30px;vertical-align:top}"];
export { styles as styles };
